import { InlineAlertAnimator, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { LinkedTaskDeleteButton } from './LinkedTaskDeleteButton';
import { LinkedTaskEditButton } from './LinkedTaskEditButton';
import { LinkedTaskMoveItemButton } from './LinkedTaskMoveItemButton';

const numberWidth = 40;
const numberMargin = 6;

const wrapperStyle = style({
  display: 'flex',
  alignItems: 'center',
});

const innerWrapperStyle = style({
  padding: `${TabStyles.Spacing.SmallSpace}px`,
  border: `1px solid ${TabStyles.Colors.L6}`,
  flex: '1 1 auto',
  display: 'flex',
});

export const numberStyle = style({
  width: numberWidth,
  textAlign: 'center',
  flex: '0 0 auto',
  display: 'inline-flex',
  marginRight: numberMargin,
});

const titleStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
});

const contentStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
  flex: '1 1 auto',
});

const expandoStyle = style({
  padding: `${TabStyles.Spacing.DefaultSpace}px`,
  border:  `1px solid ${TabStyles.Colors.L6}`,
  marginLeft: numberWidth + numberMargin,
  marginTop: -1,
});

export type LinkedTaskItemProps = {
  index: number;
  title: string;
  content?: React.ReactNode;
  buttonType?: 'edit' | 'view' | 'delete';
  expansionContent?: React.ReactNode;
  onDelete?: () => void;
  isExpanded?: boolean;
  setIsExpanded: (index: number, value: boolean) => void;
}

export function LinkedTaskItem(props: LinkedTaskItemProps): JSX.Element {
  function setIsExpanded(value: boolean) {
    props.setIsExpanded(props.index, value);
  }

  function renderButton() {
    switch(props.buttonType) {
      case 'edit':
        return <LinkedTaskEditButton isExpanded={props.isExpanded === undefined ? false : props.isExpanded} setIsExpanded={setIsExpanded}/>;
      case 'delete':
        return <LinkedTaskDeleteButton onDelete={props.onDelete}/>;
      default:
        // default type 'view'
        return;
    }
  }

  return (
    <div>
      <div className={wrapperStyle}>
        <div className={numberStyle}>
          <LinkedTaskMoveItemButton index={props.index} />
        </div>
        { props.content ? props.content :
          <div className={innerWrapperStyle}>
            <div className={titleStyle}>{props.title}</div>
            <span className={contentStyle}>{props.content}</span>
          </div>
        }
        {renderButton()}
      </div>
      <InlineAlertAnimator>
        {props.isExpanded && props.expansionContent &&
          <div className={expandoStyle}>
            {props.expansionContent}
          </div>
        }
      </InlineAlertAnimator>
    </div>
  );
}
